import { Assignment } from '../types';
import { AssignmentFormInput } from '../types/form';

export const assignmentToAssignmentFormInput = (assignment: Assignment): AssignmentFormInput => {
  const {
    name,
    expirationDate,
    scores,
    minScoreToShowExplanation,
    showSolutionsOnlyAfterExpired,
    showOnlyTotalScore,
    allowAnswersAfterTimeLimit,
    allowPracticeOnlyAfterExpired,
    timeLimit,
    exercises,
  } = assignment;
  return {
    name,
    expirationDate,
    scores,
    minScoreToShowExplanation,
    showSolutionsOnlyAfterExpired,
    showOnlyTotalScore,
    allowAnswersAfterTimeLimit,
    allowPracticeOnlyAfterExpired,
    timeLimit,
    exercises: exercises.map((exercise) => exercise.id),
  };
};
